import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiMessageSquare, FiInfo, FiTruck } from 'react-icons/fi';

const InfoModules = () => {
  const reviews = [
    { user: 'AXEL_V', rating: '5.0', text: 'Kairo Core 20k is a beast. Powered my workstation through a 15-hour flight without missing a beat.' },
    { user: 'NOMAD_JULIA', rating: '4.8', text: 'The GlobalLink adapter is the first one I\'ve owned that actually stays in the wall. Build quality is elite.' },
    { user: 'TECH_LEAD', rating: '5.0', text: 'Minimalist, functional, and rugged. This is what travel tech should be.' }
  ];

  return (
    <section className="py-20 px-4 max-w-7xl mx-auto" id="info">
      <div className="grid md:grid-cols-2 gap-10">
        
        {/* Reviews */}
        <div className="dashboard-panel p-8">
          <div className="flex items-center gap-3 mb-8 border-b border-graphite-700 pb-4">
            <SafeIcon icon={FiMessageSquare} className="text-electric text-xl" />
            <h3 className="fids-text text-sm font-bold tracking-widest uppercase">Field_Reports</h3>
          </div>
          <div className="space-y-6">
            {reviews.map((rev, i) => (
              <div key={i} className="bg-graphite-900/50 p-5 border-l-2 border-electric relative group overflow-hidden">
                <div className="absolute top-0 right-0 p-2 fids-text text-[8px] text-graphite-700 opacity-0 group-hover:opacity-100 transition-opacity">
                  ID: {Math.random().toString(36).substr(2, 6).toUpperCase()}
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="fids-text text-[10px] text-electric">USER: {rev.user}</span>
                  <span className="fids-text text-[10px] text-gray-600">RATING: {rev.rating}</span>
                </div>
                <p className="text-sm text-gray-400 fids-text leading-relaxed italic">"{rev.text}"</p>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ & Shipping */}
        <div className="space-y-10">
          <div className="dashboard-panel p-8">
            <div className="flex items-center gap-3 mb-6 border-b border-graphite-700 pb-4">
              <SafeIcon icon={FiInfo} className="text-electric text-xl" />
              <h3 className="fids-text text-sm font-bold tracking-widest uppercase">Sys_Queries</h3>
            </div>
            <div className="space-y-6 fids-text text-xs">
              <div>
                <div className="text-white font-bold mb-2">Q: FLIGHT COMPLIANCE STATUS?</div>
                <div className="text-gray-500 pl-4 border-l border-graphite-700">A: All KairoKit power modules are under 100Wh (27,027mAh) and are fully FAA/TSA compliant for carry-on.</div>
              </div>
              <div>
                <div className="text-white font-bold mb-2">Q: GAN II TECHNOLOGY BENEFITS?</div>
                <div className="text-gray-500 pl-4 border-l border-graphite-700">A: Gallium Nitride (GaN) components allow for 3x faster charging in a footprint 40% smaller than traditional silicon chargers.</div>
              </div>
            </div>
          </div>

          <div className="dashboard-panel p-8 bg-electric/5 border-electric/10">
            <div className="flex items-center gap-3 mb-6">
              <SafeIcon icon={FiTruck} className="text-electric text-xl" />
              <h3 className="fids-text text-sm font-bold tracking-widest uppercase">Logistics_Protocol</h3>
            </div>
            <div className="space-y-3 fids-text text-[10px]">
              <div className="flex justify-between text-gray-400">
                <span>INTL_PRIORITY:</span>
                <span className="text-white">2-3 BUSINESS CYCLES</span>
              </div>
              <div className="flex justify-between text-gray-400">
                <span>LOCAL_EXPEDITED:</span>
                <span className="text-white">NEXT DAY DEPLOYMENT</span>
              </div>
              <div className="mt-4 pt-4 border-t border-graphite-700 text-graphite-600">
                WARRANTY: 36-MONTH GLOBAL REPLACEMENT GUARANTEE.
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default InfoModules;